/**
 * Where the candidate review page reads from. The app renders it with no provider (the signed-in
 * org's endpoints, every action available); the shared report wraps the SAME page in a provider
 * carrying its share token, so each panel reads the share-scoped endpoint instead and every
 * edit / decision control is hidden. One page, two audiences: a change to the review page shows
 * up on shared reports automatically.
 */
import { createContext, useContext } from "react";
import type { ReactNode } from "react";

interface ReportSource {
  /** The share capability token — null in the app. */
  shareToken: string | null;
}

const Ctx = createContext<ReportSource>({ shareToken: null });

export function ReportSourceProvider({ shareToken, children }: { shareToken: string; children: ReactNode }): ReactNode {
  return <Ctx.Provider value={{ shareToken }}>{children}</Ctx.Provider>;
}

/** `readOnly` is true on a shared report: no edits, no decisions, no internal tools. */
export function useReportSource(): { shareToken: string | null; readOnly: boolean } {
  const { shareToken } = useContext(Ctx);
  return { shareToken, readOnly: shareToken !== null };
}
